export const LogoMark = ({ className = "h-9 w-9", dark = false }) => (
  <img src={dark ? "/logo-mark-dark.png" : "/logo-mark.png"} alt="LHGS logo" className={`object-contain ${className}`} />
);

export const Logo = ({ onClick }) => (
  <a href="#top" onClick={onClick} data-testid="nav-logo" className="flex items-center gap-3 group">
    <LogoMark className="h-10 w-10 transition-transform duration-500 group-hover:rotate-[-8deg]" />
    <span className="leading-none">
      <span className="block font-display font-black text-lg tracking-tight text-[#F5F5F7]">LHGS</span>
      <span className="block font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-400">
        Property Ops & Contracting
      </span>
    </span>
  </a>
);
